function ReplaceFileTypeUtil(fileType: string) {
    let fullName
    const arrFileName = fileType.split('.')
    if (arrFileName[0] === 'csb') {
        fullName = arrFileName[0]
    } else {
        const firstPhase = arrFileName[0].substring(0, 1)
        const secoundPhase = arrFileName[1].substring(0, 1)

        fullName = firstPhase + secoundPhase

    }
    return fullName
}

export default ReplaceFileTypeUtil